<template>
  <div id="hrms18e">
    <search-box-index v-show="indexDisp"
                      v-model="paramSearch"
                      :labels="labels[dash.nowLang]"
                      :labelsButton="dash.button[dash.nowLang]"
                      :button="dash.button[dash.nowLang]"
                      :nowLang="dash.nowLang"
                      searchBoxAlias="hrms18e"
                      :unLoadBool="true"
                      :searchIndex="searchIndex"
                      :traditionalDayLists="traditionalDayLists"
                      :shutdownDayLists="shutdownDayLists"
                      :receivedStore="searchAction"
                      :parentData="index.parent"
                      :parentColumns="columns[dash.nowLang].indexParent"
                      :parentEditEvent="parentEditCallEvent"
                      :parentEditInlineEventBool="true"
                      :parentSaveInlineBtnDisp="false"
                      :parentRowDisableCondition="parentRowDisableCondition"
                      :parentSearchDisp="false"
                      :parentSortDisp="false"
                      :parentCurrentTypework="parentCurrentTypework"
                      :parentTargetTypework="parentTargetTypework"
                      :parentCurrentCodshift="parentCurrentCodshift"
                      :parentTargetCodshift="parentTargetCodshift"
                      :setParentCurrentTypework="setParentCurrentTypework"
                      :setParentTargetTypework="setParentTargetTypework"
                      :setParentCurrentCodshift="setParentCurrentCodshift"
                      :setParentTargetCodshift="setParentTargetCodshift"
                      :setParentTypeworkToTargetTypework="setParentTypeworkToTargetTypework"
                      :parentColumnEvent="parentColumnEvent"
                      :setParentInlineData="setParentInlineData"
                      :parentInlineData="parentInlineData"
                      :parentCurrentDay="parentCurrentDay"
                      :setIndexChildByParent="setIndexChildByParent"
                      :childData="index.childByParent"
                      :childColumns="columns[dash.nowLang].indexChild"
                      :childEditEvent="childEditCallEvent"
                      :childAddInlineEventBool="true"
                      :childAfterAddInlineEvent="setChildDataRowAdded"
                      :childEditInlineEventBool="true"
                      :childDeleteInlineEventBool="true"
                      :childDeleteInlineBtnDisabledOlds="true"
                      :childSaveInlineBtnDisp="childSaveInlineBtnDisp"
                      :childRowDisableCondition="childRowDisableCondition"
                      :childSearchDisp="false"
                      :childSortDisp="false"
                      :childCurrentTypework="childCurrentTypework"
                      :childTargetTypework="childTargetTypework"
                      :childCurrentCodshift="childCurrentCodshift"
                      :childTargetCodshift="childTargetCodshift"
                      :setChildChildTypework="setChildChildTypework"
                      :setChildTargetTypework="setChildTargetTypework"
                      :setChildCurrentCodshift="setChildCurrentCodshift"
                      :setChildTargetCodshift="setChildTargetCodshift"
                      :setChildTypeworkToTargetTypework="setChildTypeworkToTargetTypework"
                      :childColumnEvent="childColumnEvent"
                      :setChildInlineData="setChildInlineData"
                      :childInlineData="childInlineData"
                      :childCurrentDay="childCurrentDay"
                      :postIndex="postIndex" />

    <div class="box-footer">
      <button type="button" class="hidden" data-toggle="modal" data-target="#hrms18e-popup-parent" ref="hrms18e-popup-parent">
      </button>
    </div> 
    <popup-parent     :labels="labels[dash.nowLang]"
                      :nowLang="dash.nowLang"
                      :searchIndex="searchIndex"
                      :parentPostParams="parentPostParams"
                      :parentCurrentTypework="parentCurrentTypework"
                      :parentTargetTypework="parentTargetTypework"
                      :parentCurrentCodshift="parentCurrentCodshift"
                      :parentTargetCodshift="parentTargetCodshift"
                      :setParentCurrentTypework="setParentCurrentTypework"
                      :setParentTargetTypework="setParentTargetTypework"
                      :setParentCurrentCodshift="setParentCurrentCodshift"
                      :setParentTargetCodshift="setParentTargetCodshift"
                      :setParentTypeworkToTargetTypework="setParentTypeworkToTargetTypework"
                      :postParentTypeworkCodshiftOnPeriod="postParentTypeworkCodshiftOnPeriod"
                      :childCurrentTypework="childCurrentTypework"
                      :childTargetTypework="childTargetTypework"
                      :childCurrentCodshift="childCurrentCodshift"
                      :childTargetCodshift="childTargetCodshift"
                      :setChildChildTypework="setChildChildTypework"
                      :setChildTargetTypework="setChildTargetTypework"
                      :setChildCurrentCodshift="setChildCurrentCodshift"
                      :setChildTargetCodshift="setChildTargetCodshift" />

    <div class="box-footer">
      <button type="button" class="hidden" data-toggle="modal" data-target="#hrms18e-popup-child" ref="hrms18e-popup-child">
      </button>
    </div>

    <popup-child      :labels="labels[dash.nowLang]"
                      :nowLang="dash.nowLang"
                      :searchIndex="searchIndex"
                      :parentCurrentTypework="parentCurrentTypework"
                      :parentTargetTypework="parentTargetTypework"
                      :parentCurrentCodshift="parentCurrentCodshift"
                      :parentTargetCodshift="parentTargetCodshift"
                      :setParentCurrentTypework="setParentCurrentTypework"
                      :setParentTargetTypework="setParentTargetTypework"
                      :setParentCurrentCodshift="setParentCurrentCodshift"
                      :setParentTargetCodshift="setParentTargetCodshift"
                      :setParentTypeworkToTargetTypework="setParentTypeworkToTargetTypework"
                      :postChildTypeworkCodshiftOnPeriod="postChildTypeworkCodshiftOnPeriod"
                      :childPostParams="childPostParams"
                      :childCurrentTypework="childCurrentTypework"
                      :childTargetTypework="childTargetTypework"
                      :childCurrentCodshift="childCurrentCodshift"
                      :childTargetCodshift="childTargetCodshift"
                      :setChildChildTypework="setChildChildTypework"
                      :setChildTargetTypework="setChildTargetTypework"
                      :setChildCurrentCodshift="setChildCurrentCodshift"
                      :setChildTargetCodshift="setChildTargetCodshift" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hrms18e/mutation-types'
import * as lovTypes from 'store/modules/hrmsLov/mutation-types'
import searchBoxIndex from 'components/hrms18e/searchBoxIndex'
import popupParent from 'components/hrms18e/popupParent'
import popupChild from 'components/hrms18e/popupChild'
import moment from 'moment'
import swal from 'sweetalert'

export default {
  name: 'hrms18e',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY'),
      paramSearch: {
        month: moment().month() + 1,
        year: moment().year()
      },
      parentPostParams: this.initialParams(),
      childPostParams: this.initialParams(),
      childSaveInlineBtnDisp: false
    }
  },
  created () {
    this.receivedHrms18eColumnsLabels()
  },
  computed: {
    traditionalDayLists () {
      return this.traditionalDays.rows.filter((traditionalDay) => {
        return parseInt(traditionalDay.year) === parseInt(this.searchIndex.year) &&
               parseInt(traditionalDay.month) === parseInt(this.searchIndex.month) &&
               traditionalDay.codcalen.indexOf(this.parentTargetCodcalen) > -1
      }).map((traditionalDay) => { return traditionalDay.day })
    },
    shutdownDayLists () {
      return this.shutdownDays.rows.filter((shutdownDay) => {
        return parseInt(shutdownDay.year) === parseInt(this.searchIndex.year) &&
               parseInt(shutdownDay.month) === parseInt(this.searchIndex.month) &&
               shutdownDay.codcalen.indexOf(this.parentTargetCodcalen) > -1
      }).map((shutdownDay) => { return shutdownDay.day })
    },
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRMS18E_INDEX_DISP,
      columns: types.GET_HRMS18E_COLUMNS,
      labels: types.GET_HRMS18E_LABELS,
      index: types.GET_HRMS18E_INDEX,
      searchIndex: types.GET_HRMS18E_SEARCH_INDEX,
      lovCurrentDesc: lovTypes.GET_LOV_CURRENT_DESC,
      maxRowspan: types.GET_HRMS18E_MAX_ROWSPAN,
      traditionalDays: types.GET_HRMS18E_TRADITIONAL_DAYS,
      shutdownDays: types.GET_HRMS18E_SHUTDOWN_DAYS,
      parentCurrentTypework: types.GET_HRMS18E_CURRENT_TYPEWORK_PARENT,
      parentTargetTypework: types.GET_HRMS18E_TARGET_TYPEWORK_PARENT,
      parentCurrentCodshift: types.GET_HRMS18E_CURRENT_CODSHIFT_PARENT,
      parentTargetCodshift: types.GET_HRMS18E_TARGET_CODSHIFT_PARENT,
      parentTargetCodcalen: types.GET_HRMS18E_TARGET_CODCALEN_PARENT,
      parentInlineData: types.GET_HRMS18E_INLINE_DATA_PARENT,
      parentCurrentDay: types.GET_HRMS18E_CURRENT_DAY_PARENT,
      childCurrentTypework: types.GET_HRMS18E_CURRENT_TYPEWORK_CHILD,
      childTargetTypework: types.GET_HRMS18E_TARGET_TYPEWORK_CHILD,
      childCurrentCodshift: types.GET_HRMS18E_CURRENT_CODSHIFT_CHILD,
      childTargetCodshift: types.GET_HRMS18E_TARGET_CODSHIFT_CHILD,
      childTargetCodempid: types.GET_HRMS18E_TARGET_CODEMPID_CHILD,
      childInlineData: types.GET_HRMS18E_INLINE_DATA_CHILD,
      childCurrentDay: types.GET_HRMS18E_CURRENT_DAY_CHILD
    })
  },
  methods: {
    searchAction (paramSearch) {
      if (moment(paramSearch.month + '/' + paramSearch.year, 'MM/YYYY').toDate() >= moment(moment().format('MM/YYYY'), 'MM/YYYY').toDate()) {
        this.childEditCallEvent = this.childEditEvent
        this.parentEditCallEvent = this.parentEditEvent
        this.childSaveInlineBtnDisp = true
      } else {
        this.childEditCallEvent = undefined
        this.parentEditCallEvent = undefined
        this.childSaveInlineBtnDisp = false
      }
      this.receivedHrms18eIndex(paramSearch)
    },
    initialParams () {
      return {
        dtestrt: moment().format('DD/MM/YYYY'),
        dteend: moment().format('DD/MM/YYYY'),
        codshift: '',
        period: false,
        day: [ 'SAT', 'SUN' ]
      }
    },
    parentColumnEvent (eventName, dataRow, event) {
      if (event.type === 'focusin') {
        if (dataRow.codcalen !== this.parentTargetCodcalen) {
          this.setParentTargetCodcalen(dataRow.codcalen)
          this.setIndexChildByParent(dataRow)
        }
        this.setParentCurrentDay(eventName.replace('codshift', ''))
        this.setParentCurrentCodshift(dataRow[eventName])
        this.setParentTargetCodshift(eventName)
        this.setParentCurrentTypework(dataRow['typwork' + eventName.substring(8)])
        this.setParentTargetTypework('typwork' + eventName.substring(8))
      }
      if (event.type === 'focusout') {
        this.setParentCodshiftToTargetCodshift({ codshift: dataRow[eventName], targetCodshift: this.parentTargetCodshift })
      }
    },
    parentEditCallEvent (dataRow) {
    },
    parentEditEvent (dataRow) {
      if (dataRow.codcalen !== this.parentTargetCodcalen) {
        this.setParentTargetCodcalen(dataRow.codcalen)
        this.setIndexChildByParent(dataRow)
      }
      this.parentPostParams = this.initialParams()
      this.$refs['hrms18e-popup-parent'].click()
    },
    parentRowDisableCondition () {
      // console.log('parentRowDisableCondition')
    },
    childColumnEvent (eventName, dataRow, event) {
      switch (eventName) {
        case 'codempid':
          if (dataRow.codempid !== '' && event.type !== 'focusin' && event.type !== 'focusout') {
            let valid = true
            for (var i = 0; i < this.index.child.rows.length - 1; i++) {
              if (this.index.child.rows[i].codempid === dataRow.codempid) {
                valid = false
              }
            }
            if (valid) {
              let descCodempid = this.lovCurrentDesc('codempid', dataRow.codempid)
              this.setChildAddInlineCodempid({ codempid: dataRow.codempid, descCodempid: descCodempid })
            } else {
              this.setChildAddInlineCodempid({ codempid: dataRow.codempid, descCodempid: '' })
              swal({
                title: 'ยืนยันการทำรายการ',
                text: 'รายการนี้ได้ถูกเลือกไปแล้ว'
              })
            }
          }
          break
        default:
          if (event.type === 'focusin') {
            this.setChildCurrentDay(eventName.replace('codshift', ''))
            this.setChildCurrentCodshift(dataRow[eventName])
            this.setChildTargetCodshift(eventName)
            this.setChildTargetCodempid(dataRow.codempid)
            this.setChildCurrentTypework(dataRow['typwork' + eventName.substring(8)])
            this.setChildTargetTypework('typwork' + eventName.substring(8))
          }
          if (event.type === 'change') {
            this.setChildCodshiftToTargetCodshift({ codshift: dataRow[eventName], targetCodshift: eventName })
          }
          break
      }
    },
    childEditCallEvent (dataRow) {
    },
    childEditEvent (dataRow) {
      if (dataRow.codempid !== this.childTargetCodempid) {
        this.setChildTargetCodempid(dataRow.codempid)
      }
      this.childPostParams = this.initialParams()
      this.$refs['hrms18e-popup-child'].click()
    },
    childRowDisableCondition () {
      // console.log('childRowDisableCondition')
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRMS18E_INDEX_SELECTED,
      setIndexChildByParent: types.SET_HRMS18E_INDEX_CHILD_BY_PARENT,
      setParentCurrentTypework: types.SET_HRMS18E_CURRENT_TYPEWORK_PARENT,
      setParentTargetTypework: types.SET_HRMS18E_TARGET_TYPEWORK_PARENT,
      setParentCurrentCodshift: types.SET_HRMS18E_CURRENT_CODSHIFT_PARENT,
      setParentTargetCodshift: types.SET_HRMS18E_TARGET_CODSHIFT_PARENT,
      setParentTypeworkToTargetTypework: types.SET_HRMS18E_TYPEWORK_TO_TARGET_TYPEWORK_PARENT,
      setParentCodshiftToTargetCodshift: types.SET_HRMS18E_CODSHIFT_TO_TARGET_CODSHIFT_PARENT,
      setParentTargetCodcalen: types.SET_HRMS18E_TARGET_CODCALEN_PARENT,
      setParentInlineData: types.SET_HRMS18E_INLINE_DATA_PARENT,
      setParentCurrentDay: types.SET_HRMS18E_CURRENT_DAY_PARENT,
      setChildCurrentTypework: types.SET_HRMS18E_CURRENT_TYPEWORK_CHILD,
      setChildTargetTypework: types.SET_HRMS18E_TARGET_TYPEWORK_CHILD,
      setChildCurrentCodshift: types.SET_HRMS18E_CURRENT_CODSHIFT_CHILD,
      setChildTargetCodshift: types.SET_HRMS18E_TARGET_CODSHIFT_CHILD,
      setChildTargetCodempid: types.SET_HRMS18E_TARGET_CODEMPID_CHILD,
      setChildDataRowAdded: types.SET_HRMS18E_ADDED_DATA_ROW_CHILD,
      setChildTypeworkToTargetTypework: types.SET_HRMS18E_TYPEWORK_TO_TARGET_TYPEWORK_CHILD,
      setChildCodshiftToTargetCodshift: types.SET_HRMS18E_CODSHIFT_TO_TARGET_CODSHIFT_CHILD,
      setChildAddInlineCodempid: types.SET_HRMS18E_ADD_INLINE_CODEMPID_CHILD,
      setChildInlineData: types.SET_HRMS18E_INLINE_DATA_CHILD,
      setChildCurrentDay: types.SET_HRMS18E_CURRENT_DAY_CHILD
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRMS18E_PAGE,
      receivedHrms18eColumnsLabels: types.RECEIVED_HRMS18E_COLUMNS_LABELS,
      receivedHrms18eTraditionalDays: types.RECEIVED_HRMS18E_TRADITIONAL_DAYS,
      receivedHrms18eIndex: types.RECEIVED_HRMS18E_INDEX,
      postChildTypeworkCodshiftOnPeriod: types.POST_HRMS18E_TYPEWORK_CODSHIFT_ON_PERIOD_CHILD,
      postParentTypeworkCodshiftOnPeriod: types.POST_HRMS18E_TYPEWORK_CODSHIFT_ON_PERIOD_PARENT,
      postIndex: types.POST_HRMS18E_INDEX_SAVE
    })
  },
  components: {
    searchBoxIndex,
    popupParent,
    popupChild
  }
}
</script>

<style lang="scss">
  
/* Class for Day in Table */
.typework-w-cell {
  padding: 0;
  border-top: 1px solid #E0E0E0;
  border-left: 1px solid #E0E0E0;
  border-right: 1px solid #E0E0E0;
  border-bottom: 2px solid #FFF;

  input {
    color: #9e9e9e;
  }
}

.typework-h-cell {
  padding: 0;
  border-top: 1px solid #E0E0E0;
  border-left: 1px solid #E0E0E0;
  border-right: 1px solid #E0E0E0;
  border-bottom: 2px solid #D32F2F;
  
  input {
    color: #D32F2F;
  }
}

.typework-t-cell {
  padding: 0;
  border-top: 1px solid #E0E0E0;
  border-left: 1px solid #E0E0E0;
  border-right: 1px solid #E0E0E0;
  border-bottom: 2px solid #66BB6A;

  input {
    color: #66BB6A;
  }
}

.typework-s-cell {
  padding: 0;
  border-top: 1px solid #E0E0E0;
  border-left: 1px solid #E0E0E0;
  border-right: 1px solid #E0E0E0;
  border-bottom: 2px solid #0277BD;
  
  input {
    color: #0277BD;
  }
}

.typework-l-cell {
  padding: 0;
  border-top: 1px solid #E0E0E0;
  border-left: 1px solid #E0E0E0;
  border-right: 1px solid #E0E0E0;
  border-bottom: 2px solid #FFA726;
    
  input {
    color: #FFA726;
  }
}

</style>


// WEBPACK FOOTER //
// component.vue?62e6c17b